import { render, staticRenderFns } from "./gljg.vue?vue&type=template&id=1d7d01e9&scoped=true"
import script from "./gljg.vue?vue&type=script&lang=js"
export * from "./gljg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d01e9",
  null
  
)

export default component.exports